import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';

import { fadeInOut } from '../../../shared/helpers/animations';


@Component({
    selector: 'app-no-esg-access-modal',
    templateUrl: 'no-esg-access-modal.component.html',
    styleUrls: ['no-esg-access-modal.component.scss'],
    animations: [fadeInOut],
    standalone: false
})
export class NoEsgAccessModalComponent implements OnInit{
  // Modal properties
  position: object = { X: 'center', Y: 'center' };
  modalWidth = '30%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  subscription: any;
  eSignatureErrorMessage: any;
  public message: string;
  constructor(private router: Router) {
    this.message = 'NoEsgAccessModalComponent constructor';
  }

  ngOnInit() {
    // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  noAccessModalClose() {
    this.router.navigate(['/home']);
  }
}
